import { graphHooks } from '@tunasong/graph-lib/react'
import { dayjs } from '@tunasong/models'
import type { Entity, Persisted } from '@tunasong/schemas'
import { getEntityPath, metaSeparator, useNavigateToEntity, useParentChain } from '@tunasong/ui-lib'
import type { FC, MouseEvent } from 'react'
import styles from './collaborators-section.module.css'

export interface CollaboratorRowProps {
  entity: Persisted<Entity>
  /** Who edited it last; the row only claims "edited" because that is what `lastEditedBy` records */
  editorId: string
}

/** "{Name} edited {Title}" over "{Space} · {time}". One link per row, stretched over the whole row. */
export const CollaboratorRow: FC<CollaboratorRowProps> = props => {
  const { entity, editorId } = props
  const navigateToEntity = useNavigateToEntity()
  const { profile } = graphHooks.useProfile(editorId)
  const parentChain = useParentChain(entity)

  const editorName = profile?.name ?? profile?.email ?? 'Someone'
  const space = parentChain.find(ancestor => ancestor.id !== entity.id && Boolean(ancestor.name))?.name
  const when = dayjs(entity.updatedAt).fromNow()

  const handleClick = (ev: MouseEvent) => {
    ev.preventDefault()
    navigateToEntity(entity)
  }

  return (
    <li className={styles.row}>
      <a className={styles.link} href={getEntityPath({ entity })} onClick={handleClick}>
        {editorName} edited {entity.name ?? 'an untitled item'}
      </a>
      <span className={styles.meta}>{space ? `${space}${metaSeparator}${when}` : when}</span>
    </li>
  )
}

export default CollaboratorRow
